
import { Options, Vue } from 'vue-class-component'

@Options({
  name: 'LayoutDefault',
})
export default class LayoutDefault extends Vue {}
